import { render } from "./HomeworkDetailView.vue?vue&type=template&id=25bdec77"
import script from "./HomeworkDetailView.vue?vue&type=script&lang=js"
export * from "./HomeworkDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__